import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS
} from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'CSVViewer',
  label: 'CSV Viewer',
  icon: 'DocumentTextIcon',
  description:
    'Gets the contents of a CSV file in the browser given a url and puts it in local storage under the specified key',
  properties: [
    {
      label: 'Storage CSV File Path',
      name: 'url',
      editor: 'textbox',
      readonly: false,
      description:
        'The path to the file on firebase storage. Either specify this or "Local Store File Path Key Name"',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Local Store Key Name',
      name: 'localStoreKeyName',
      editor: 'textbox',
      readonly: false,
      description:
        'The name of the key to store the file contents in the local store',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Local Store File Path Key Name',
      name: 'localStoreFileStoragePathKeyName',
      editor: 'textbox',
      readonly: false,
      description:
        'The name of the key in the local store that contains a file path to get a signed url for and parse.',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ]
};

export default fields;
